module.exports = __webpack_public_path__ + "img/treatments-directory-notices-en.d2f7fb87.jpg";